import { Component, Inject, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GrowlerService } from '../../../shared/growler/growler.service';
import { MatDialogSizes } from '../../../../enums/mat-dialog-sizes.enum';

export interface ConfirmWithInputDialogInput
{
    btnContent: string;
    content?: string;
    title: string;
    defaultValue?: string;
    label: string;
    inputRequired: boolean;
}

export interface ConfirmWithInputDialogResult
{
    success: boolean;
    value: string;
}

@Component({
    selector: 'app-confirm-with-input-dialog',
    templateUrl: './confirm-with-input-dialog.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MatDialogModule,
    ],
})

export class ConfirmWithInputDialogComponent implements OnInit
{
    static readonly width = MatDialogSizes.SM;
    form: UntypedFormGroup = null;

    constructor(
            private _dialogRef: MatDialogRef<ConfirmWithInputDialogComponent>,
            private _formBuilder: UntypedFormBuilder,
            private _growler: GrowlerService,
            @Inject(MAT_DIALOG_DATA) public data: ConfirmWithInputDialogInput,
    ) {
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            inputValue: [
                this.data.defaultValue || '',
                this.data.inputRequired ? [Validators.required] : [],
            ],
        });
    }

    closeAndConfirm() {
        if (this.form.invalid) {
            this._growler.error('Missing Reason', 'The reason is a required field.');
            return;
        }
        this._dialogRef.close(<ConfirmWithInputDialogResult>{success: true, value: this.form.get('inputValue').value});
    }

}
